module.exports = __webpack_public_path__ + "static/favicon-4e6b99c4315bf5d97adbbb792891f062.ico";